import createReducer from '../utils/createReducer';
import {
  GLOBAL_SETTINGS_REQUEST,
  GLOBAL_SETTINGS_SUCCESS,
  GLOBAL_SETTINGS_FAILURE,
} from '../constants/actions';

const initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null,
};

export default createReducer(initialState, {
  [GLOBAL_SETTINGS_REQUEST]: state => (
    Object.assign({}, state, {
      isError: false,
    })
  ),
  [GLOBAL_SETTINGS_SUCCESS]: (state, payload) => (
    Object.assign({}, state, {
      data: [].concat(payload.data),
      token: payload.token,
    })
  ),
  [GLOBAL_SETTINGS_FAILURE]: (state, payload) => (
    Object.assign({}, state, {
      isError: true,
      statusText: payload.message,
    })
  ),
});



// WEBPACK FOOTER //
// ./src/reducers/globalSettings.js